import { apiClient } from "@base/api/client";
import { useSuspenseQuery } from "@tanstack/react-query";
import type { UseSuspenseQueryOptions } from "@tanstack/react-query";

export interface ProjectMember {
  id: number;
  name: string;
}

export interface ProjectDetail {
  id: number;
  name: string;
  thumbnail_image_url: string;
  address: string;
  timezone: string;
  members: ProjectMember[];
}

async function fetchProjectDetail(projectId: string): Promise<ProjectDetail> {
  const response = await apiClient.get<ProjectDetail>(`/project-management/api/projects/${projectId}`);
  return response.data;
}

export function projectDetailQueryOptions(projectId: string) {
  return {
    queryKey: ["project-detail", projectId] as const,
    queryFn: () => fetchProjectDetail(projectId),
  };
}

export function useProjectDetailQuery(
  projectId: string,
  options?: Omit<UseSuspenseQueryOptions<ProjectDetail>, "queryKey" | "queryFn">,
) {
  return useSuspenseQuery({ ...projectDetailQueryOptions(projectId), ...options });
}
